import { render, staticRenderFns } from "./xtPurchaRecordReportList.vue?vue&type=template&id=728b8248"
import script from "./xtPurchaRecordReportList.vue?vue&type=script&lang=js"
export * from "./xtPurchaRecordReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports